import Explorer from '../views/Explorer.vue'
import Cover from '../views/Cover.vue'

export default [
  {
	  path: '/explorer/:version/:versionName?/:mode/:layout?/:lng?',
    name: 'explorer',
    component: Explorer,
  },
  {
	  path: '/cover/:version/:versionName?/:mode/:layout?/:lng?',
    name: 'cover',
    component: Cover,
  },
]
